
export const isTestMode = () => {
  if (process.env.REACT_APP_TEST_MODE === 'true') {
    return true;
  }
  
  if (typeof window !== 'undefined' && window.localStorage?.getItem('TEST_MODE') === 'true') {
    return true;
  }
  
  if (typeof window !== 'undefined' && window.location?.search?.includes('test=true')) {
    return true;
  }
  
  if (typeof window !== 'undefined' && window.Cypress) {
    return true;
  }
  
  if (process.env.NODE_ENV === 'test') {
    return true;
  }
  
  return false;
};


export const enableTestMode = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('TEST_MODE', 'true');
    console.log('🧪 Test mode enabled');
  }
};


export const disableTestMode = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem('TEST_MODE');
    console.log('✅ Test mode disabled');
  }
};


export const initTestMode = () => {
  if (isTestMode()) {
    console.log('🧪 Running in TEST MODE');
    
    if (typeof window !== 'undefined') {
      window.__TEST_MODE__ = true;
      window.localStorage.setItem('TEST_MODE', 'true');
    }
    
    return true;
  }
  
  return false;
};

export default {
  isTestMode,
  enableTestMode,
  disableTestMode,
  initTestMode
};